module.exports = __webpack_public_path__ + "img/concert.70a03554.jpg";